import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Home, Gamepad2, Baby, BookOpen, User } from 'lucide-react';

const Nav = styled.nav`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 512px;
  background: rgba(255,255,255,0.92);
  backdrop-filter: blur(16px);
  border-top: 1px solid #e2e8f0;
  border-radius: 20px 20px 0 0;
  padding: 10px 24px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 100;
  box-shadow: 0 -4px 20px rgba(0,0,0,0.06);
  font-family: 'Plus Jakarta Sans', sans-serif;
`;

const NavItem = styled.button<{ active?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  background: none;
  border: none;
  cursor: pointer;
  color: ${p => p.active ? '#2DBCAF' : '#94a3b8'};
  transition: color 0.15s;
  padding: 0;
  svg {
    width: 24px;
    height: 24px;
    stroke-width: ${p => p.active ? 2.5 : 1.75};
  }
  span:last-child {
    font-size: 10px;
    font-weight: ${p => p.active ? '700' : '600'};
    font-family: inherit;
  }
`;

const NAV_ITEMS = [
  { label: 'Beranda', icon: Home,      path: '/' },
  { label: 'Game',    icon: Gamepad2,  path: '/games' },
  { label: 'Tumbuh',  icon: Baby,      path: '/tumbuh-kembang' },
  { label: 'Dongeng', icon: BookOpen,  path: '/dongeng' },
  { label: 'Profil',  icon: User,      path: '/profile' },
];

export default function BottomNavBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <Nav>
      {NAV_ITEMS.map(item => {
        const Icon = item.icon;
        const isActive = pathname === item.path;
        return (
          <NavItem
            key={item.path}
            active={isActive}
            onClick={() => navigate(item.path)}
          >
            <Icon />
            <span>{item.label}</span>
          </NavItem>
        );
      })}
    </Nav>
  );
}
